<template>
  <div class="AdvertisementsStates">
    <CircleDisplay
      class="Circle"
      :title="$t('advertisements.percentages-states')"
      :options="options"
      :series="sectors"
    />
  </div>
</template>

<script>
import { CircleDisplay } from '@/components';
import { getStatesOfAdvertisements } from '@/api';

const colors = ['#95c623', '#e84855', '#5ec0ff'];
export default {
  name: 'AdvertisementsStates',
  components: {
    CircleDisplay,
  },
  data() {
    return {
      sectors: [],
      options: {
        labels: [
          this.$t('advertisements.active'),
          this.$t('advertisements.paused'),
          this.$t('advertisements.pending'),
        ],
        colors,
      },
    };
  },
  created() {
    getStatesOfAdvertisements().then(
      data => {
        this.sectors = Object.values(data);
      },
      err => {
        console.log('Fetch Error: ', err);
      }
    );
  },
};
</script>

<style lang="scss">
.AdvertisementsStates {
  width: 35%;
  margin-left: rem(10);
}
</style>
